import * as React from "react";
import "./badges.css";
import "../../style/fonts.css";
import BadgeChainList from "../badges/badgeChainList";
import moment from "moment";

export interface Props {
  badges: any;
  style?: any;
}
const badgeCategories = [
  "LEVEL_1",
  "LEVEL_2",
  "LEVEL_3",
  "LEVEL_4",
  "LEVEL_5",
  "LEVEL_6",
  "MONEY",
  "HEALTH",
  "CHALLENGE",
  "HIGHFIVE",
  "SUPPORT",
  "SUPPORTING",
  "SHARE"
];

class Badges extends React.Component<Props, any> {
  constructor(props: Props) {
    super(props);
  }

  compareBadges(badge1, badge2) {
    if (secs(badge1.date) > secs(badge2.date)) {
      return 1;
    } else if (secs(badge1.date) === secs(badge2.date)) {
      return 0;
    } else {
      return -1;
    }
  }

  badgeOp() {
    if (this.props.badges) {
      const badgeChains = {};
      const badges = this.props.badges;
      badgeCategories.map(category => {
        let state = 0;
        badges.map(badge => {
          if (category == badge.category && badge.state > state) {
            state = badge.state;
          }
        });
        badgeChains[category] = { state: state, category: category };
      });
      return <BadgeChainList badgeChain={badgeChains} />;
    } else return null;
  }

  render() {
    return (
      <div className="BADGES_CONT" style={this.props.style}>
        <div className="BADGES_CONT_INNER">{this.badgeOp()}</div>
      </div>
    );
  }
}

export default Badges;

function secs(start): number {
  const start_date = moment(start).startOf("second");
  const today = moment(new Date()).startOf("second");
  const duration = moment.duration(today.diff(start_date));
  return duration.asSeconds();
}



// WEBPACK FOOTER //
// ./src/components/badges/badges.tsx